module.exports = __webpack_public_path__ + "static/media/pm.afaa12be.webp";